import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'
import Thanks from '../pages/Thanks.vue'
import ThanksES from '../pages/ThanksES.vue'
import ThanksEN from '../pages/ThanksEN.vue'
import PalletsEs from '../pages/PalletsEs.vue'
import PalletsEn from '../pages/PalletsEn.vue'
import Privacy from '../pages/Privacy.vue'
import Blog from '../pages/Post.vue'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    savedPosition.x = 0
    savedPosition.y = 0
    return savedPosition
  } else {
    const position = {}

    if (to.hash) {
      position.selector = to.hash
      if (document.querySelector(to.hash)) {
        return position
      }
      return false
    }
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/thanks',
        name: 'Thanks',
        component: Thanks
    },
    {
        path: '/gracias-pallets',
        name: 'ThanksES',
        component: ThanksES
    },
    {
        path: '/thanks-pallets',
        name: 'ThanksEN',
        component: ThanksEN
    },
    {
        path: '/pallets-en-baja-California',
        name: 'PalletsEs',
        component: PalletsEs
    },
    {
        path: '/pallets-for-sale-baja-california',
        name: 'PalletsEn',
        component: PalletsEn
    },
    {
        path: '/aviso-de-privacidad',
        name: 'Privacy',
        component: Privacy
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog
    }
  ]
})


router.beforeEach((to, from, next) => {
  next()
})

export default router